var map = {
	"./close.png": 4856,
	"./file.png": 7408,
	"./forestedness.png": 18,
	"./licence.png": 713,
	"./link.png": 5530,
	"./marker-icon-inactive.png": 379,
	"./marker-icon.png": 8735,
	"./municipals.png": 5065,
	"./pattern-cell.png": 7212,
	"./pattern-line-2.png": 3777,
	"./pattern-line-3.png": 2860,
	"./pattern-line.png": 2580,
	"./pattern-star.png": 8996,
	"./pattern-subsoil-use.png": 9356,
	"./pattern-sun.png": 7970,
	"./pattern-unsuitable.png": 894,
	"./reviewer.png": 3560,
	"./unsuitable.png": 938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5492;